module.exports = __webpack_public_path__ + "static/media/clock.c8b0ba68.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/WatchFace/watch/clock.png
// module id = 801
// module chunks = 0